import { useEffect, useState } from "react";
import { TableViewServices } from "../services/table-view";
import {
  ITableViewColumn,
  ITableViewResponse,
  TableViewFilters,
} from "../interfaces/table-view";

export interface ColumnConfig {
  column: string;
  label: string;
  isDisplay: number;
  sortOrder: number;
}

interface TableViewProps {
  columnDefault: ITableViewColumn[];
  filterDefault?: TableViewFilters ;
  tableName: string;
}

interface UpdateTableViewParams {
  tableName: string;
  columns?: ITableViewColumn[];
  filters?: TableViewFilters;
}

export const useTableView = ({
  columnDefault,
  filterDefault = {} as TableViewFilters,
  tableName,
}: TableViewProps) => {
  const [columns, setColumns] = useState<ITableViewColumn[]>(columnDefault);
  const [filters, setFilters] = useState(filterDefault);
  const [loading, setLoading] = useState(true);

  const fetchTableView = async () => {
    try {
      setLoading(true);
      const response = await TableViewServices.getCustomView(tableName);
      const data: ITableViewResponse["data"] = response.data;
      
      if (Array.isArray(data?.columns) && data?.columns?.length > 0) {
        setColumns(data.columns);
      } else {
        setColumns(columnDefault);
      }
 
      if (data?.filters) {
        setFilters(data.filters);
      } else {
        setFilters(filterDefault);
      }
    } catch (error) {
      console.error("Fetch customize view error:", error);
      setColumns(columnDefault);
      setFilters(filterDefault);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTableView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    columns,
    setColumns,
    filters,
    setFilters,
    loading,
  };
};

export const useUpdateTableView = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateTableView = async ({
    tableName,
    columns,
    filters,
  }: UpdateTableViewParams): Promise<boolean> => {
    try {
      setLoading(true);
      setError(null);
      await TableViewServices.updateCustomView(tableName, {
        columns,
        filters,
      });
      setLoading(false);
      return true;
    } catch (err: any) {
      setError(err);
      setLoading(false);
      return false;
    }
  };

  return {
    loading,
    error,
    updateTableView,
  };
};
